var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 132,
    viewBox: "0 0 257 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9263 22.1468C78.0979 4.29148 117.586 -5.31441 155.39 -6.67083C193.194 -8.02724 227.746 4.12326 259.046 29.7807C290.345 55.4381 286.613 76.1301 247.848 91.8569C209.084 107.584 171.5 117.503 135.096 121.616C98.6929 125.729 62.9374 114.643 27.83 88.3577C-7.27733 62.0725 -4.24524 40.0022 36.9263 22.1468Z",
    fill: "#BCBCF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1253 -23.9193C106.785 -32.9463 150.54 -34.7261 191.389 -29.2587C232.238 -23.7912 267.797 -6.54593 298.065 22.4773C328.333 51.5004 321.573 69.7655 277.785 77.2725C233.997 84.7795 192.249 87.1843 152.541 84.4868C112.833 81.7893 75.8387 65.304 41.5574 35.0308C7.27602 4.75768 13.4653 -14.8924 60.1253 -23.9193Z",
    fill: "#3737A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.aeef46b236cc1ef77ce6a53f40105a6d.svg";
export { ForwardRef as ReactComponent };